import IconFacebook from './IconFacebook';
import IconTwitter from './IconTwitter';
import IconInstagram from './IconInstagram';
import IconYoutube from './IconYoutube';
import IconDerek from './IconDerek';
import IconCrane from './IconCrane';
import IconAmbulance from './IconAmbulance';
import IconVMS from './IconVMS';
import IconCCTV from './IconCCTV';
import IconWireRope from './IconWireRope';
import IconCallCenter from './IconCallCenter';
import IconStatusLattol from './IconStatusLattol';
import IconGenset from './IconGenset';
import IconGPS from './IconGPS';
import IconBack from './IconBack';
import IconNext from './IconNext';
import IconPlus from './IconPlus';
import IconMin from './IconMin';
import IconLogo from './IconLogo';
import IconLangId from './IconLangId';
import IconLangEn from './IconLangEn';

const Icons = {
  IconFacebook,
  IconTwitter,
  IconInstagram,
  IconYoutube,
  IconDerek,
  IconCrane,
  IconAmbulance,
  IconVMS,
  IconCCTV,
  IconWireRope,
  IconCallCenter,
  IconStatusLattol,
  IconGenset,
  IconGPS,
  IconBack,
  IconNext,
  IconPlus,
  IconMin,
  IconLogo,
  IconLangId,
  IconLangEn,
};

export default Icons;
